module.exports = __webpack_public_path__ + "static/media/expand-square.3c0c9497.svg";